import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'reducers';
import { useHistory, Link } from 'react-router-dom';
import { 
	ArrowLeft
} from 'assets/icons';

const BackComponent = () => {
	const header = useSelector((state: RootState) => state.header);
	const subheader = useSelector((state: RootState) => state.subheader);

	return (
		<div id="back-component">
			{
				header.onBack && (
					<div className="arrow-back" onClick={ header.onBack }>
						<img src={ ArrowLeft } />
					</div>
				)
			}
			<div className="container-titles">
				<h3 className="title-top">{ header.title }</h3>
				<h4 className="subtitle-top">{ subheader.title }</h4>
			</div>
		</div>
	)
}

export default BackComponent;